var map = {
	"./SENEH - (2 x 135 cm).jpg": 6332,
	"./Tappeto BIJAR - (215 x 145 cm).jpg": 4537,
	"./Tappeto ISFAHAN - 1880 (395 x 275 cm).jpg": 1183,
	"./Tappeto ISFAHAN - 1920 (435 x 340 cm).jpg": 4490,
	"./Tappeto Isfahan - (215 x 140 cm).jpg": 6094,
	"./Tappeto Isfahan - (300 x 200 cm).jpg": 4638,
	"./Tappeto Isfahan - (340 x 225 cm).jpg": 2157,
	"./Tappeto Isfahan - Periodo 1930 - (225 x 145 cm).jpg": 868,
	"./Tappeto KASHAN - (200 x 130 cm).jpg": 8025,
	"./Tappeto KASHAN - (370 x 235 cm).jpg": 2631,
	"./Tappeto KASHAN - (375 x 270 cm).jpg": 3795,
	"./Tappeto KASHAN - DABIR - (205 x 130 cm).jpg": 2999,
	"./Tappeto KASHAN - Firmato (2 x 130 cm).jpg": 8191,
	"./Tappeto KASHAN Mohtasham - 1890 (215 x 135 cm).jpg": 5790,
	"./Tappeto KASHAN Mohtasham - Firmato - 1880 (200 x 130 cm).jpg": 8327,
	"./Tappeto KERMAN - 1910 (240 x 140 cm).jpg": 1767,
	"./Tappeto KERMAN - Firmato Milani - 1880 (220 x 140 cm).jpg": 1606,
	"./Tappeto Kerman - (190 x 140 cm).jpg": 6542,
	"./Tappeto Kerman - (210 x 110 cm).jpg": 7906,
	"./Tappeto MASHHAD - Firmato SABER - 1930 (490 x 360 cm).jpg": 2288,
	"./Tappeto Nain -Tudeshk - (315 x 210 cm).jpg": 1292,
	"./Tappeto Qum - Botteh (205 x 136 cm).jpg": 3649,
	"./Tappeto Qum - Seta e firmato - 1960 (300 x 200 cm).jpg": 4648,
	"./Tappeto SILK KASHAN - Firmato Gastelli - 1880 (120 x 80 cm).jpg": 3218,
	"./Tappeto Sirjan - (350 x 255 cm).jpg": 3756,
	"./Tappeto Tabriz - (180 x 147cm).jpg": 6888,
	"./Tappeto Tabriz - (290 x 215 cm).jpg": 3386,
	"./Tappeto Tabriz - Quadrato - (350 x 350 cm).jpg": 6001,
	"./Tappeto Teheran - (222 x 140 cm).jpg": 2629,
	"./Tappeto Tudeshk - (230 x 150 cm).jpg": 7138,
	"./Tappeto afshari - Firmato - (225 x 150 cm).jpg": 1995,
	"./Tappeto antico - Sarogh (375 x 280 cm).jpg": 5974,
	"./Tappeto antico - Torkaman - (335 x 220 cm).jpg": 1164,
	"./Tappeto antico 1920 - Iran nord-orientale (300 x 200 cm).jpg": 4727,
	"./Tappeto cinese Pechino - Disegno Drago - 1920 (380 x 320 cm).jpg": 869,
	"./Tappeto persiano - Golfarang (295 x 190cm).jpg": 851,
	"./Tappeto pura seta Qum - (300 x 200 cm).jpg": 7426,
	"./Tappeto sarugh - (375 x 280 cm).jpg": 7736,
	"./Tappeto turcomano - (330 x 190 cm).jpg": 1463
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 484;